export class EquipmentTransfer {
    id!: string
    indexId!: number
    equipment!: string
    fromJob!: string
    forJob!: string
    transferDate!: Date
    requestedById!: string
    transferById!: string
    requestedByHrRef!: number
    transferByHrRef!: number
    notes!: string
    requestApprovedById!: string
    requestApprovedByHrRef!: number
    completeDate!: Date | undefined
    isComplete!: boolean
    imageUrls!: string[]
}
